import * as React from 'react';
import { InjectApp, InjectTranslate } from '../app/app';
import { withRouter } from 'react-router';
import { inject } from 'mobx-react';
import { AppStore } from '../../stores/app-store';
import { DateView } from '../widgets/date-view';
import { DurationView } from '../widgets/duration-view';

type InjectedProps = InjectApp & InjectTranslate;

export class SegmentInfoInner extends React.Component<InjectedProps> {
  private readonly store: AppStore;

  constructor(props: InjectedProps) {
    super(props);
    this.store = props.app;
  }

  public render() {
    const { t } = this.props;
    const { segment } = this.store.booking;

    return (
      <div className="segment-info container">
        <h1>{t('flight_info.header')}</h1>
        <p>
          <DateView date={segment.departureUtc} format="dddd, LL" />
        </p>

        <table>
          <thead>
            <tr>
              <th>{segment.originCode}</th>
              <th>{segment.destinationCode}</th>
              <th>{t('flight_info.direct')}</th>
              <th className="red">{t('flight_info.delay_time')}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <DateView date={segment.departureLocal} format="LT" />
              </td>
              <td>
                <DateView date={segment.arrivalLocal} format="LT" />
              </td>
              <td>
                <DurationView minutes={segment.flightDuration.asMinutes()} />
              </td>
              <td className="red">
                <DurationView minutes={segment.delayMinutes.asMinutes()} />
              </td>
            </tr>
          </tbody>
        </table>

        <p className="small-text">
          {t('common.flight')} {segment.carrierCode} {segment.flightNumber}
          <span className="with-padding-left">
            {t('flight_info.operated_by')} {segment.operatedBy}
          </span>
        </p>
      </div>
    );
  }
}

export const SegmentInfo: React.ComponentClass = withRouter(
  inject('app', 't')(SegmentInfoInner),
);



// WEBPACK FOOTER //
// ../node_modules/source-map-loader!./src/components/segment/segment-info.tsx